import React, {Component} from 'react'
import PropTypes from 'prop-types'

class MgValidating extends Component{
	render() {
		const { message } = this.props
		return (
			<div className="col-xs-8 col-md-8 bv-landing-section">
				<div className="col-xs-9 col-md-9 center-dom">
					<div className="" style={{ width: "100%", height: "330px", backgroundColor: "#4B5A71" }}>
						<div className="pg-loading-center-outer" style={{ paddingTop: "100px" }}>
							<div className="pg-loading-center-middle">
								<h1 className="pg-loading-logo-header">
									<img className="pg-loading-logo" src="/assets/new-logo.png"/>
								</h1>
								<div className="pg-loading-html">
									<p className="pg-loading-message">The Ultimate WordPress Backup & Security Service</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="clearfix" style={{ height: "30px" }}></div>
				<span className="bv-progress-running-status bv-progress-spinner"></span>
				<p className="bv-landing-title">
					{ message }
				</p>
			</div>
		)
	}
}

MgValidating.propTypes = {
	message: PropTypes.string
}

export default MgValidating
